var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "new_top" },
        [_c("header2"), _vm._v(" "), _c("navigation")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "new_content" },
        [
          _c("div", { staticClass: "nc_pindao_title" }, [
            _c("p", { staticClass: "ncpt_line" }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$route.query.subjectName))])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "nc1" },
            [
              _c("div", { staticClass: "ncn_pic_subject f_l" }, [
                _c(
                  "div",
                  { attrs: { id: "flexslider" } },
                  [
                    _c(
                      "el-carousel",
                      { attrs: { trigger: "click", height: "265px" } },
                      _vm._l(_vm.secondCarousel, function(item) {
                        return _c("el-carousel-item", { key: item.id }, [
                          _c(
                            "a",
                            { attrs: { target: "_blank", href: item.url } },
                            [
                              _c("img", {
                                attrs: {
                                  src: item.imgUrl,
                                  width: "545",
                                  height: "265"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", { staticClass: "flex-caption" }, [
                            _vm._v(_vm._s(item.title))
                          ])
                        ])
                      }),
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c("newsSimpleList", {
                staticClass: "f_r ncn_text2",
                attrs: { settings: _vm.trainingDynamicNewsSettings }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("medicalDynamicNews", {
            attrs: {
              parentTagId: _vm.$route.query.subject1
                ? _vm.$route.query.subject1.toString()
                : _vm.$route.query.subject1,
              tagId: _vm.$route.query.subject2
                ? _vm.$route.query.subject2.toString()
                : _vm.$route.query.subject2
            }
          }),
          _vm._v(" "),
          _c("perfectCourseSimpleList", {
            attrs: {
              perfectPosition: _vm.perfectPosition,
              orPerfectPosition: "3,0;"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("footer1")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19f5fa4e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19f5fa4e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/SecondSubject.vue
// module id = null
// module chunks = 